module.exports = __webpack_public_path__ + "img/bg-gifts.8d5fa7b1.jpg";